import auth from '@middlewares/Auth';

export default [
  {
    url: '/projects',
    page: 'projects/Index',
    name: 'projects',
    meta: {
      label: 'Dashboard',
      layout: 'Dashboard',
      middleware: [auth],
      role: {
        only: ['tourism-operator', 'tourist', 'admin'],
      },
    },
    group: [
      {
        url: '/projects/create',
        page: 'projects/Create',
        name: 'new-project',
        role: {
          only: ['tourism-operator'],
        },
      },
      {
        url: '/projects/:id',
        page: 'projects/Create',
        name: 'edit-project',
        role: {
          only: ['tourism-operator'],
        },
      },
    ],
  },
];
